import React, { Component } from 'react';

class Home extends Component {
  render() {
      return<div><p>what up</p></div>
      
  }
}

export default Home;